import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import InfiniteScroll from "react-infinite-scroller";
import * as matchesActions from "../../_actions/matchesActions";
import getRecentlyViewed from "../../_selectors/matchesSelectors/getRecentlyViewed";
import UserWidgetContainer from "../Matches/UserWidgetContainer";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import { updateObject } from "../../_utils";
import matchesConstants from "../../_constants/matchesConstants";
import getMatchesLastResult from "../../_selectors/matchesSelectors/getMatchesLastResult";
import HoverWidget from "../UI/HoverWidget";
class RecentlyViewed extends Component {
  componentDidMount() {
    const { updateHeader, updateBreadcrumb, getRecentlyViewed } = this.props;
    updateHeader({
      title: "Recently Viewed",
      description: "Members that you viewed recently"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Recently Viewed", link: "/search" }
    ]);
    getRecentlyViewed();
  }
  componentWillUnmount() {
    const { clearMembers, clearRecentlyViewed } = this.props;
    clearMembers();
    clearRecentlyViewed();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members you recently viewed"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.profileId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getRecentlyViewed(state),
  lastResult: getMatchesLastResult(state)
});

const mapDispatchToProps = dispatch => ({
  getRecentlyViewed: () => dispatch(matchesActions.recentlyViewedMembers()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearRecentlyViewed: () =>
    dispatch(matchesActions.clearRecentlyViewedMembers()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, {
          type: matchesConstants.RECENTLY_VIEWED_MEMBERS
        })
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecentlyViewed);



// WEBPACK FOOTER //
// ./src/_components/RecentlyViewed/index.js